<template>
  <div >
  	<div class="filter-inline-panel cle">
      <el-form :inline="true" size="mini" :model="filters" class="filter-panel fl">
        <el-form-item>
        	<el-date-picker v-model="filters.time" value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.start_date')" :end-placeholder="$t('course_index.end_date')"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="handleCurrentChange(1)">{{$t('index.query')}}</el-button>
          <el-button type="" size="mini" @click="reset">{{$t('index.reset')}}</el-button>
        </el-form-item>
      </el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" v-if="hasBtn('export')" @click="export_f">{{$t('index.export')}}</el-button>
      </div>
    </div>
    <div v-if="list">
	    <el-table :data="list" border size="mini">
	      <el-table-column prop="order_id" align="center" label="ID">
	      	<template slot-scope="scope">
	      		<router-link :to="{path:'/order_info',query:{ id: scope.row.order_id }}" class="transaction_id">{{scope.row.order_id}}</router-link>
	      	</template>
	      </el-table-column>
	      <el-table-column prop="pay_method" align="center" :label="$t('order.payment')"></el-table-column>
	      <el-table-column prop="price" align="center" :label="$t('order.refund')"></el-table-column>
	      <el-table-column prop="user_name" align="center" :label="$t('journal.user_name')"></el-table-column>
	      <el-table-column prop="create_time" align="center" :label="$t('journal.create_time')">
	        <template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
	      </el-table-column>
	      <!-- <el-table-column prop="action" align="center" :label="$t('index.operation')"></el-table-column> -->
		<el-table-column prop="remarks" align="center" :label="$t('order.notes')"></el-table-column>
	    </el-table>
    </div>
    <div class="page-pagination">
      <el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
	data() {
		return {
			list: [],
			filters:{
				type:'',
				time:null,
			},
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
		}
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "adminRefundRecord";
			var datas = {
				page:this_.pages.page,
				num: this_.pages.perpage,
			};
			var time = this_.filters.time;
			if (time) {
				datas['start_time']=Math.round(time[0]/1000);
				datas['end_time']=Math.round(time[1]/1000);
			}
			this_.list=[];
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		reset(){
			this.filters.time=null;
			this.handleCurrentChange(1);
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		export_f(){
			var this_ = this;
			var TokenId = sessionStorage.getItem('TokenId');
			var lang = localStorage.getItem('lang') != 'cn' ? 'us' : 'cn';
			var url=process.env.API_ROOT+'/adminRefundRecordExport?TokenId=' + TokenId + '&language=' + lang + '&page='+this_.pages.page+'&num='+this_.pages.perpage;
			if (this_.filters.time) {
				url+='&start_time='+Math.round(this_.filters.time[0]/1000);
				url+='&end_time='+Math.round(this_.filters.time[1]/1000);
			}
			console.log(url)
			window.open(url);
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.transaction_id {
	color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/views/journal/record.vue